(function () {
  'use strict';

  function hideHomepageLegacyBars() {
    if (!document.body || !document.body.classList.contains('template-index')) return;

    var style = document.getElementById('nuvra-hide-legacy-bars');
    if (!style) {
      style = document.createElement('style');
      style.id = 'nuvra-hide-legacy-bars';
      style.textContent =
        'body.template-index #header-group .header-section,' +
        'body.template-index #header-group .header-section #header-component,' +
        'body.template-index #header-group .header-section .header__row,' +
        'body.template-index .nuvra-mp-trust-section{display:none!important;height:0!important;overflow:hidden!important}';
      document.head.appendChild(style);
    }

    document
      .querySelectorAll('.nuvra-mp-trust-section, #header-group .header-section, #header-component')
      .forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      });
  }

  if (document.body) {
    hideHomepageLegacyBars();
  } else {
    document.addEventListener('DOMContentLoaded', hideHomepageLegacyBars);
  }

  var taglines = [
    'Real talk designs. No corporate overlords.',
    'Etsy for people who keep getting banned.',
    'Banned from Amazon. Banned from Etsy. Still printing.',
    'No safe spaces. No apologies. Just cotton.',
    'We don\'t censor your humor — we print it.',
    'Premium ring-spun cotton. Zero filter.',
  ];

  function initCollectionSort() {
    var sortSelect = document.querySelector('[data-nuvra-collection-sort]');
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  function initTaglineRotator() {
    const el = document.querySelector('[data-nuvra-tagline]');
    if (!el) return;
    let i = 0;
    el.textContent = taglines[0];
    setInterval(() => {
      i = (i + 1) % taglines.length;
      el.innerHTML = '<span>' + taglines[i] + '</span>';
    }, 3500);
  }

  function initReveal() {
    const items = document.querySelectorAll('.nuvra-reveal');
    if (!items.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    items.forEach((el) => observer.observe(el));
  }

  function initCountdown() {
    const root = document.querySelector('[data-nuvra-countdown]');
    if (!root) return;
    const end = root.dataset.end;
    if (!end) return;
    const target = new Date(end.replace(' ', 'T')).getTime();

    function tick() {
      const now = Date.now();
      const diff = Math.max(0, target - now);
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      const set = (key, val) => {
        const node = root.querySelector('[data-unit="' + key + '"]');
        if (node) node.textContent = String(val).padStart(2, '0');
      };
      set('days', d);
      set('hours', h);
      set('minutes', m);
      set('seconds', s);
    }
    tick();
    setInterval(tick, 1000);
  }

  function initAjaxCart() {
    document.querySelectorAll('[data-nuvra-add]').forEach((btn) => {
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        const id = this.dataset.variantId;
        if (!id) return;
        const original = this.textContent;
        this.textContent = 'ADDING...';
        this.disabled = true;
        try {
          const res = await fetch(window.Shopify?.routes?.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
          });
          if (res.ok) {
            this.textContent = 'IN THE BAG ✓';
            document.dispatchEvent(new CustomEvent('cart:update'));
          } else {
            this.textContent = 'OOPS';
          }
        } catch {
          this.textContent = 'OOPS';
        }
        setTimeout(() => {
          this.textContent = original;
          this.disabled = false;
        }, 2000);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function initInfiniteScroll() {
    document.querySelectorAll('[data-nuvra-infinite-root]').forEach(function (root) {
      var grid = root.querySelector('[data-nuvra-infinite-grid]');
      var sentinel = root.querySelector('[data-nuvra-infinite-sentinel]');
      if (!grid || !sentinel) return;

      var nextUrl = sentinel.getAttribute('data-next-url');
      var loading = false;
      var loader = sentinel.querySelector('[data-nuvra-infinite-loader]');

      if (!nextUrl) {
        sentinel.hidden = true;
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting || !nextUrl || loading) return;
          loading = true;
          if (loader) loader.hidden = false;

          fetch(nextUrl)
            .then(function (res) {
              return res.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var newGrid = doc.querySelector('[data-nuvra-infinite-grid]');
              if (newGrid) {
                newGrid.querySelectorAll('.nuvra-listing').forEach(function (item) {
                  item.classList.add('is-visible');
                  grid.appendChild(item);
                });
              }
              var newSentinel = doc.querySelector('[data-nuvra-infinite-sentinel]');
              nextUrl = newSentinel ? newSentinel.getAttribute('data-next-url') : '';
              if (nextUrl) {
                sentinel.setAttribute('data-next-url', nextUrl);
              } else {
                sentinel.removeAttribute('data-next-url');
                sentinel.hidden = true;
                observer.disconnect();
              }
            })
            .catch(function () {
              sentinel.hidden = true;
              observer.disconnect();
            })
            .finally(function () {
              loading = false;
              if (loader) loader.hidden = true;
              initAjaxCart();
            });
        },
        { rootMargin: '600px' }
      );

      observer.observe(sentinel);
    });
  }

  function formatMoney(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function buildScrollProductCard(product, collectionTitle) {
    var item = document.createElement('div');
    item.className = 'nuvra-scroll-item';
    item.dataset.productId = String(product.id);

    var image = product.images && product.images[0] ? product.images[0].src : '';
    var title = product.title || '';
    var price = formatMoney(product.variants && product.variants[0] ? product.variants[0].price : 0);
    var url = '/products/' + product.handle;
    var tag = collectionTitle
      ? '<span class="nuvra-product-card__collection-tag">' + collectionTitle + '</span>'
      : '';

    item.innerHTML =
      '<article class="nuvra-product-card">' +
      '<div class="nuvra-product-card__image-wrap">' +
      '<a href="' + url + '">' +
      (image ? '<img src="' + image + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
      '</a>' +
      tag +
      '</div>' +
      '<div class="nuvra-product-card__info">' +
      '<h3 class="nuvra-product-card__title"><a href="' + url + '">' + title + '</a></h3>' +
      '<div class="nuvra-product-card__price">' + price + '</div>' +
      '</div>' +
      '</article>';

    return item;
  }

  function initCollectionScroll() {
    document.querySelectorAll('[data-nuvra-collection-scroll]').forEach(function (section) {
      var row = section.querySelector('[data-nuvra-scroll-row]');
      var prev = section.querySelector('[data-nuvra-scroll-prev]');
      var next = section.querySelector('[data-nuvra-scroll-next]');
      if (!row) return;

      var handle = section.dataset.handle;
      var total = parseInt(section.dataset.count, 10) || 0;
      var title = section.dataset.title || '';

      function updateNav() {
        if (!prev || !next) return;
        var maxScroll = row.scrollWidth - row.clientWidth;
        prev.disabled = row.scrollLeft <= 4;
        next.disabled = row.scrollLeft >= maxScroll - 4;
      }

      function scrollByPage(direction) {
        row.scrollBy({ left: direction * row.clientWidth * 0.85, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollByPage(-1); });
      if (next) next.addEventListener('click', function () { scrollByPage(1); });
      row.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();

      if (!handle || !total) return;

      var rendered = row.querySelectorAll('[data-product-id]').length;
      if (rendered >= total) return;

      fetch('/collections/' + handle + '/products.json?limit=250')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = data.products || [];
          var existing = {};
          row.querySelectorAll('[data-product-id]').forEach(function (node) {
            existing[node.dataset.productId] = true;
          });

          products.forEach(function (product) {
            if (existing[String(product.id)]) return;
            row.appendChild(buildScrollProductCard(product, title));
          });

          var countNode = section.querySelector('[data-nuvra-scroll-count]');
          if (countNode) countNode.textContent = String(products.length || total);
          updateNav();
        })
        .catch(function () {
          /* keep liquid-rendered products */
        });
    });
  }

  function hideHomepageLegacyBars() {
    if (!document.body || !document.body.classList.contains('template-index')) return;

    var style = document.getElementById('nuvra-hide-legacy-bars');
    if (!style) {
      style = document.createElement('style');
      style.id = 'nuvra-hide-legacy-bars';
      style.textContent =
        'body.template-index #header-group .header-section,' +
        'body.template-index #header-group .header-section #header-component,' +
        'body.template-index #header-group .header-section .header__row,' +
        'body.template-index .nuvra-mp-trust-section{display:none!important;height:0!important;overflow:hidden!important}';
      document.head.appendChild(style);
    }

    document
      .querySelectorAll('.nuvra-mp-trust-section, #header-group .header-section, #header-component')
      .forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      });
  }

  function init() {
    hideHomepageLegacyBars();
    initTaglineRotator();
    initReveal();
    initCountdown();
    initCollectionSort();
    initInfiniteScroll();
    initCollectionScroll();
    initAjaxCart();
  }
})();
